import React, { Component } from "react"
import { Link } from "react-router-dom"
import styled from "@emotion/styled"
import { Menu } from "../Menu"
import { ReactComponent as Logo } from "../img/logo-old.svg"
import { Above } from "../UI/Helpers"

const HeaderWrapper = styled("header")`
  background: red;
  height: 84px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  position: relative;
  top: 0;
  width: 100%;
  background: white;
  z-index: 5;
  ${props => props.theme.bp.below.md} {
  }
  .logoWrapper {
    width: 104px;
    height: 44px;
    background: transparent;
    svg {
      width: 104px;
      height: 44px;
      path {
        fill: black;
      }
    }
    ${props => props.theme.bp.below.sm} {
      padding: 1.5rem;
      height: 120px;
    }
  }
`;

const MyPagesLink = styled("a")`
  text-decoration: none;
  color: black;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: ${props => props.theme.colors.primary};
  color: white;
  padding: 0.5rem 1rem 0.5rem 0.5rem;
  border-radius: 100px;
  height: 32px;
  .icon {
    width: 20px;
    height: 20px;
    background: white;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 12px;
      height: 12px;
      path {
        fill: ${props => props.theme.colors.primary};
      }
    }
  }
  .text {
    font-family: ${props => props.theme.fonts.headings};
  }
`;

const HeaderContent = props => {
  return (
    <HeaderWrapper>
      <div className="logoWrapper">
        <Link to="/">
          <Logo />
        </Link>
      </div>
      <Menu {...props} />
      <Above size="lg">
        <MyPagesLink href="https://orvelin.realportal.nu/common/portal.php" target="_blank" rel="noopener noreferrer">
          <span className="icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"/></svg>
          </span>
          <span className="text">
            Mina sidor
          </span>
        </MyPagesLink>
      </Above>
    </HeaderWrapper>
  )
}

class Header extends Component {
  state = {
    open: false,
    search: false
  }

  toggleMenu = () => {
    this.setState({ open: !this.state.open })
  }

  toggleSearch = () => {
    this.setState({ search: !this.state.search })
  }
  render() {
    return (
      <HeaderContent
        {...this.state}
        toggleMenu={this.toggleMenu}
        toggleSearch={this.toggleSearch}
      />
    )
  }
}

export default Header
